__turbopack_context__.v({
  "heading": "PartnerLogoMarquee-module__VpA5nG__heading",
  "mark": "PartnerLogoMarquee-module__VpA5nG__mark",
  "masked": "PartnerLogoMarquee-module__VpA5nG__masked",
  "row": "PartnerLogoMarquee-module__VpA5nG__row",
  "strip": "PartnerLogoMarquee-module__VpA5nG__strip",
});
